import {useCallback, useContext, useEffect, useState} from 'react';

import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';

import {LeftAlignIcon} from '~library/svg/LeftAlignIcon';
import {RightAlignIcon} from '~library/svg/RightAlignIcon';
import {MiddleAlignIcon} from '~library/svg/MiddleAlignIcon';

import {TextFormatAlignmentBase} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextFormat/components/Alignment/TextFormatAlignmentBase/TextFormatAlignmentBase';

export const Alignment = ({className}) => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [selectedAlignment, setAlignment] = useState();

  useEffect(() => {
    const updateAlignment = () => setAlignment(canvas?.getActiveObjects()?.[0]?.textAlign);

    updateAlignment();
    canvas?.on('object:reset', updateAlignment);

    return () => {
      canvas?.off('object:reset', updateAlignment);
    };
  }, [canvas, activeObjects]);

  const changeAlignment = useCallback(
    (align) =>
      canvas.getActiveObjects().forEach((obj) => {
        setAlignment(align);
        obj.set('textAlign', align);
        canvas.requestRenderAll();
        canvas.fire('object:modified');
      }),
    [canvas]
  );

  const leftAlignment = useCallback(() => changeAlignment('left'), [changeAlignment]);
  const middleAlignment = useCallback(() => changeAlignment('center'), [changeAlignment]);
  const rightAlignment = useCallback(() => changeAlignment('right'), [changeAlignment]);

  return (
    <div className={className}>
      <TextFormatAlignmentBase
        // eslint-disable-next-line camelcase
        icon={LeftAlignIcon}
        onClick={leftAlignment}
        active={selectedAlignment === 'left'}
        dataQaId="step1-textformat-leftalign"
      />
      <TextFormatAlignmentBase
        // eslint-disable-next-line camelcase
        icon={MiddleAlignIcon}
        onClick={middleAlignment}
        active={selectedAlignment === 'center'}
        dataQaId="step1-textformat-centeralign"
      />
      <TextFormatAlignmentBase
        // eslint-disable-next-line camelcase
        icon={RightAlignIcon}
        onClick={rightAlignment}
        active={selectedAlignment === 'right'}
        dataQaId="step1-textformat-rightalign"
      />
    </div>
  );
};
